<template>
    <small class="required">
        {{ message }}
    </small>
</template>

<script>
    export default {
        props: ['message']
    }
</script>
